import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { ILead, IDropdown, IContact } from "../../models/BaseModel";
import { useForm } from 'react-hook-form';
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useEffect, useState } from "react";
import { Fetch } from "../../shared/Fetch";
import { JVDropdown } from "../../shared/JVDropdown";
import { Tag } from "primereact/tag";

const schema = yup.object({

    userId: yup.number().when('sourceId', {
        is: 3,
        then: schema => schema.required("Internal User is required").min(1, "Internal User is required"),
        otherwise: schema => schema.nullable(),
    }),

    assignedTo: yup.number().nullable(),
});

interface Iprops {
    contacts: ILead[],
    open: boolean,
    hideDialog: () => void,
    toast: any,
    onSuccess: () => void
}

export const TransferLead = (props: Iprops) => {
    const [users, setUsers] = useState<IDropdown[]>();
    const [submitting, setSubmitting] = useState(false);

    const { control, handleSubmit, formState: { errors }, reset, watch, setValue } = useForm<ILead>({
        resolver: yupResolver(schema),
        defaultValues: { statusId: 5 },
        shouldFocusError: false,
    });

    useEffect(() => {
        loadUsers();
    }, []);

    const loadUsers = async () => {
        const response = await Fetch("Dropdown/getuser", "GET", null, null, null);
        if (response) {
            setUsers(await response.json());
        }
    }



    const saveToDB = async (body: ILead) => {
        setSubmitting(true);
        body.leadId = props.contacts.map(c => c.id ?? 0);
        const response = await Fetch(`lead/transfer`, "POST", body, null, props.toast);
        if (response) {
            onHide();
            props.toast.current.show({ severity: 'success', detail: "Lead Transfer Successfully!", life: 3000 });
            props.onSuccess();
        }
        setSubmitting(false);
    }

    const onHide = () => {
        props.hideDialog();
        reset({});
    }

    function onSubmit(data: ILead) {
        saveToDB(data);
    }


    return (
        <Dialog visible={props.open} style={{ width: '80vw', maxWidth: '800px' }} header="Transfer Lead" modal className="p-fluid" onHide={onHide}>
            <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid">
                {/* <div className="flex flex-wrap gap-2 mb-3 ml-3">
                    {props.contacts.map((cont, index) => {
                        return <div key={index} className="flex items-center">
                            <Tag className="mr-2 py-2 px-3" severity="warning" icon="pi pi-user" value={cont.contactName}></Tag>
                        </div>
                    })}
                </div> */}
                <div className="field col-12 md:col-6">
                    <div className="flex items-center">
                        <Tag className="mr-2 py-2 px-3" severity="warning" icon="pi pi-user" value={`${props.contacts.length} Contact(s) selected`}></Tag>
                    </div>
                </div>
                <JVDropdown column={1} required label="Internal User" control={control} options={users} optionLabel="name" optionValue="id" name="newAssignedToId" placeholder="Select Internal User" error={errors.userId?.message} />
                <div className="col-12 md:col-12 flex gap-4 justify-content-end">
                    <Button style={{ width: '100px' }} loading={submitting} label="SAVE" type="submit" className="p-button-rounded"></Button>
                    <Button style={{ width: '100px' }} label="CLOSE" onClick={onHide} type="button" className="p-button-rounded p-button-outlined surface-200"></Button>
                </div>
            </form>
        </Dialog>
    );
}